
import React, { useState, useMemo } from 'react';
import { Search, ChevronLeft, ChevronRight } from 'lucide-react';
import './estyle.css';
import { IMAGE_BASE_URL } from '../../config';  

const EmployeeCard = ({employees, onSelectEmployee, itemsPerPage}) => {

console.log('card employeess:',employees);
  

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  // Filter employees based on search term
  const filteredEmployees = useMemo(() => {
    return employees.filter(employee =>
      employee.firstName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [employees, searchTerm]);

  // Calculate pagination
  const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentEmployees = filteredEmployees.slice(startIndex, startIndex + itemsPerPage);

  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Reset to first page when search changes
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  // Simple pagination display
  const getPageInfo = () => {
    return `Page ${currentPage} of ${totalPages}`;
  };

  return (
    <div className="employee-cards-container">
      <div className="search-container">
        <div className="search-input-wrapper">
          <Search className="search-icon" size={20} />
          <input
            type="text"
            placeholder="Search employees..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="search-input"
          />
        </div>
      </div>

      <div className="cards-grid">
        {currentEmployees.map((employee) => (
          <div key={employee.id} className="employee-card" onClick={() => onSelectEmployee(employee.employeeId, employee)}>
            <div className="card-image-container">
              <img
                src={`${IMAGE_BASE_URL}${employee.image}`}
                alt={employee.firstName}
                className="employee-image"
              />
            </div>
            <div className="card-content">
              <h6 className="employee-name">{employee.firstName} {employee.lastName}</h6>
            </div>
          </div>
        ))}
      </div>

      {filteredEmployees.length === 0 && (
        <div className="no-results">
          <p>No employees found matching your search.</p>
        </div>
      )}

      {totalPages > 1 && (
        <div className="pagination-container">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn prev-btn"
          >
            <ChevronLeft size={20} />
            Previous
          </button>

          <div className="page-numbers">
            <span className="page-info">{getPageInfo()}</span>
          </div>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn next-btn"
          >
            Next
            <ChevronRight size={20} />
          </button>
        </div>
      )}

      {/* <div className="results-info">
        Showing {startIndex + 1}-
        {Math.min(startIndex + itemsPerPage, filteredEmployees.length)} of{' '}
        {filteredEmployees.length} employees
      </div> */}
    </div>
  );
};

export default EmployeeCard;
// import React, { useState, useMemo } from 'react';
// import { Search, ChevronLeft, ChevronRight } from 'lucide-react';
// import './estyle.css';
// import { IMAGE_BASE_URL } from '../../config';  

// const EmployeeCard = ({employees, onSelectEmployee, itemsPerPage}) => {

// console.log('card employeess:',employees);
  

//   const [searchTerm, setSearchTerm] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   //const itemsPerPage = 3;

//   // Filter employees based on search term
//   const filteredEmployees = useMemo(() => {
//     return employees.filter(employee =>
//       employee.firstName.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//   }, [employees, searchTerm]);

//   // Calculate pagination
//   const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentEmployees = filteredEmployees.slice(startIndex, startIndex + itemsPerPage);

//   // Handle page change
//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   // Reset to first page when search changes
//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   // -------- Pagination Range Logic --------
//   const getPaginationRange = () => {
//   const maxVisibleButtons = 5; // Maximum number of page buttons to show
//   const pages = [];

//   if (totalPages <= maxVisibleButtons) {
//     // Show all pages if total is less than or equal to max
//     for (let i = 1; i <= totalPages; i++) pages.push(i);
//     return pages;
//   }

//   // Always show first page
//   pages.push(1);

//   // Determine if we need dots and middle pages
//   if (currentPage <= 3) {
//     // Near the start: 1 2 3 4 ... Last
//     for (let i = 2; i <= 4; i++) {
//       pages.push(i);
//     }
//     pages.push("...");
//     pages.push(totalPages);
//   } else if (currentPage >= totalPages - 2) {
//     // Near the end: 1 ... Last-3 Last-2 Last-1 Last
//     pages.push("...");
//     for (let i = totalPages - 3; i <= totalPages; i++) {
//       pages.push(i);
//     }
//   } else {
//     // In the middle: 1 ... Current-1 Current Current+1 ... Last
//     pages.push("...");
//     pages.push(currentPage - 1);
//     pages.push(currentPage);
//     pages.push(currentPage + 1);
//     pages.push("...");
//     pages.push(totalPages);
//   }

//   return pages;
// };

//   const paginationRange = getPaginationRange();

//   return (
//     <div className="employee-cards-container">
//       <div className="search-container">
//         <div className="search-input-wrapper">
//           <Search className="search-icon" size={20} />
//           <input
//             type="text"
//             placeholder="Search employees..."
//             value={searchTerm}
//             onChange={handleSearchChange}
//             className="search-input"
//           />
//         </div>
//       </div>

//       <div className="cards-grid">
//         {currentEmployees.map((employee) => (
//           <div key={employee.id} className="employee-card" onClick={() => onSelectEmployee(employee.employeeId, employee)}>
//             <div className="card-image-container">
//               <img
//                 //src={employee.image}
//                 src={`${IMAGE_BASE_URL}${employee.image}`}
//                 alt={employee.firstName}
//                 className="employee-image"
//               />
//             </div>
//             <div className="card-content">
//               <h6 className="employee-name">{employee.firstName} {employee.lastName}</h6>
//             </div>
//           </div>
//         ))}
//       </div>

//       {filteredEmployees.length === 0 && (
//         <div className="no-results">
//           <p>No employees found matching your search.</p>
//         </div>
//       )}

//       {totalPages > 1 && (
//         <div className="pagination-container">
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             className="pagination-btn prev-btn"
//           >
//             <ChevronLeft size={20} />
            
//           </button>

//           <div className="page-numbers">
//             {/* {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//               <button
//                 key={page}
//                 onClick={() => handlePageChange(page)}
//                 className={`page-btn ${currentPage === page ? 'active' : ''}`}
//               >
//                 {page}
//               </button>
//             ))} */}
//             {paginationRange.map((page, index) =>
//               page === "..." ? (
//                 <span key={index} className="dots">
//                   ...
//                 </span>
//               ) : (
//                 <button
//                   key={page}
//                   onClick={() => handlePageChange(page)}
//                   className={`page-btn ${currentPage === page ? 'active' : ''}`}
//                 >
//                   {page}
//                 </button>
//               )
//             )}
            
//           </div>

//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//             className="pagination-btn next-btn"
//           >
            
//             <ChevronRight size={20} />
//           </button>
//         </div>
//       )}

//       <div className="results-info">
//         {/* Showing {startIndex + 1}-{Math.min(startIndex + itemsPerPage, filteredEmployees.length)} of {filteredEmployees.length} employees */}
//         Showing {startIndex + 1}-
//         {Math.min(startIndex + itemsPerPage, filteredEmployees.length)} of{' '}
//         {filteredEmployees.length} employees
//       </div>
//     </div>
//   );
// };

// export default EmployeeCard;
